import { HttpService } from '../../App/services/http'

export const UnitService = {
    units,
    types,
    groups,
    filter,
    add,
    edit,
    remove
}

function units (params) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/units`, options, true)
        .then(response => {
            return response
        })
}

function types (params) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/unit/types`, options, true)
        .then(response => {
            return response
        })
}

function groups (params) {
    const options = {
        method: 'GET',
        params: params
    }

    return HttpService.http(`/unit/groups`, options, true)
        .then(response => {
            return response
        })
}

function filter (params = {}) {
    const options = {
        method: 'GET',
        params: params.params
    }

    return HttpService.http(`/unit/filter`, options, true)
        .then(response => {
            return response
        })
}

function add (values) {
    const options = {
        method: 'POST',
        body: JSON.stringify(values)
    }

    return HttpService.http(`/unit`, options, true)
        .then(response => {
            return response
        })
}

function edit (id, values) {
    const options = {
        method: 'PUT',
        body: JSON.stringify(values)
    }

    return HttpService.http(`/unit/${id}`, options, true)
        .then(response => {
            return response
        })
}

function remove (id) {
    const options = {
        method: 'DELETE'
    }

    return HttpService.http(`/unit/${id}`, options, true)
        .then(response => {
            return response
        })
}

